import { useState } from "react";
import { isEmailValid, isPhoneValid, normalizePhoneInput } from "./validators";

export function usePhoneField(initial = "") {
  const [value, setValue] = useState(initial);
  const [message, setMessage] = useState("");
  const [invalid, setInvalid] = useState(false);

  const onChange = (raw: string) => {
    const next = normalizePhoneInput(raw);
    setValue(next);
    const digits = next.replace(/\D/g, "");
    if (!digits.length) {
      setMessage("");
      setInvalid(false);
    } else if (digits.length < 10) {
      setMessage("");
      setInvalid(false);
    } else if (isPhoneValid(next)) {
      setMessage("");
      setInvalid(false);
    } else {
      setMessage("Check the number.");
      setInvalid(true);
    }
  };

  const onBlur = () => {
    const digits = value.replace(/\D/g, "");
    if (digits.length && digits.length < 10) {
      setMessage("Ten digits, please.");
      setInvalid(true);
    }
  };

  const validate = () => {
    const ok = isPhoneValid(value);
    if (!ok) {
      setMessage("Check the number.");
      setInvalid(true);
    }
    return ok;
  };

  return { value, message, invalid, onChange, onBlur, validate };
}

export function useEmailField(initial = "") {
  const [value, setValue] = useState(initial);
  const [message, setMessage] = useState("");
  const [invalid, setInvalid] = useState(false);

  const onChange = (next: string) => {
    setValue(next);
    if (message && isEmailValid(next)) {
      setMessage("");
      setInvalid(false);
    }
  };

  const onBlur = () => {
    const v = value.trim();
    if (v && !isEmailValid(v)) {
      setMessage("Check the address.");
      setInvalid(true);
    } else {
      setMessage("");
      setInvalid(false);
    }
  };

  const validate = () => {
    const ok = isEmailValid(value);
    if (!ok) {
      setMessage("Check the address.");
      setInvalid(true);
    }
    return ok;
  };

  return { value, message, invalid, onChange, onBlur, validate };
}
